import SpokenLanguagesComponent from "../../../../components/partner/Settings/spoken-languages/spoken-languages";

export default function SpokenLanguages() {
  return <SpokenLanguagesComponent />;
}
